import "@expo/metro-runtime";
import { registerRootComponent } from "expo";
import { ExpoRoot } from "expo-router";

// Must be exported or Fast Refresh won't update the context
export function App() {
  const ctx = require.context("./app");
  return <ExpoRoot context={ctx} />;
}

// Guard root registration so Fast Refresh / HMR does not mount duplicate roots
declare global {
  var __EXPO_APP_ROOT_REGISTERED__: boolean | undefined;
}

if (!globalThis.__EXPO_APP_ROOT_REGISTERED__) {
  globalThis.__EXPO_APP_ROOT_REGISTERED__ = true;
  registerRootComponent(App);
}
